module.exports = __webpack_public_path__ + "img/Bold 2px-chevron_down.9ce5bb2a.svg";